import RoutePoint from './point';

export default class PricingTransfer {
  from = null;

  to = null;

  dictionary = {};

  constructor (point, waitTime, dictionary = {}) {
    this.dictionary = dictionary.dictionaries || dictionary;
    this.addFrom(point, waitTime);
  }

  addTo (point, waitTime) {
    this.to = new RoutePoint(point, waitTime, 'transfer', this.dictionary);
  }

  addFrom (point, waitTime) {
    this.from = new RoutePoint(point, waitTime, 'transfer', this.dictionary);
  }

  get waitTime () {
    return this.to ? this.to.waitTime : this.from.waitTime;
  }

  get fullName () {
    let result = this.from.name;
    if (this.from.showCode) result += ` (${this.from.code}`;
    if (this.to) {
      if (this.to.showCode) result += ` - ${this.to.code})`;
      else result += `- ${this.to.name}`;
    } else if (this.from.showCode) result += `)`;
    return result;
  }
};
